module.exports = __webpack_public_path__ + "assets/img/feature_02.dd1f51ac.png";